import { defineStore } from "pinia";
import { reactive, ref, Ref } from "vue"
import { api } from "@/plugins/api"

export const useCatalogStore = defineStore("catalog", () => {
  const universes: Array<any> = reactive([])
  const categories: Array<any> = reactive([])
  const products: Array<any> = reactive([])
  const history: Array<any> = reactive([])
  const activeProductSlug: Ref<null|string> = ref(null)

  const fetchUniverses = async () => {
    const {data} = await api.categories.index({depth: 3})
    universes.slice(0, universes.length)
    universes.push(...(data.data.items || []))
  }

  const fetchCategories = async () => {
    const {data} = await api.categories.index()
    categories.slice(0, categories.length)
    categories.push(...(data.data.items || []))
  }

  const fetchProducts = async () => {
    let next = true
    let page = null
    let perPage = null
    products.slice(0, products.length)
    while (next) {
      const {data}: any = await api.products.getListProducts({
        page,
        perPage
      })
      const dataItems: [] = data?.data?.items || []
      products.push(...dataItems)
      next = !!data?.data?.next.page
      page = data?.data?.next.page
      perPage = data?.data?.next.perPage
    }
  }

  const pushInHistory = (product: any) => {
    const indexInHistory: number = history.findIndex(p => p.id === product.id)
    if (indexInHistory > -1)
      history.splice(indexInHistory, 1)
    history.unshift(product)
    if (history.length > 3)
      history.splice(3,1)
  }

  return {
    universes,
    categories,
    products,
    history,
    activeProductSlug,
    fetchUniverses,
    fetchCategories,
    fetchProducts,
    pushInHistory
  }
})